import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatNumberToLocale } from 'utils/localeNumber'

const Total = (props) => {
  const { total } = props
  const { t } = useTranslation()
  return (
    <div className="pagination-total">
      {t('Total {{number}} Items', { number: formatNumberToLocale(total) })}
    </div>
  )
}

export default Total
